
/** IMPORT COMPONENT */
import React, { useEffect , useState } from "react"
import { useSelector } from 'react-redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import { notification , Spin } from "antd";
import { useDispatch } from 'react-redux';

/** IMPORT PAGE */
import Layout from './components/Layout'
import Login from "./../src/Page/Login"
import LoginSuccess from "./../src/Page/Login/loginSuccess"
import FogotPassword from "Page/Login/FogotPassword";
import ForgetPass from "./../src/Page/ForgetPass"
import AddBooking from "./Page/AddBooking"
import CustomerSchedule from "./Page/Schedule"
import Documentary from './Page/Documentary'
import Accreditation from "./../src/Page/Accreditation/listAccreditation"
import AccreditationPublic from "./../src/Page/AccreditationPublic"
import ListEditAccreditation from '../src/Page/Accreditation/listEditAccreditation'
import ListReportStaistic from '../src/Page/Accreditation/listReportStatistic'
import Setting from "./../src/Page/Setting"
import InspectionProcessService from "./services/inspectionProcessService"
// import LoginService from "../src/services/loginService";
// import Statistical from "./Page/Statistical";
import New from "../src/Page/New"
import SMS from "./Page/SMS"
// import CreateNewCustomer from "Page/Accreditation/createNewCustomer";
import TwoFAPage from "Page/Login/twoFAPage";
import SettingLandingPage from "Page/Setting/settingLandingPage";
import InspectionProcess from "Page/InspectionProcess";
import ManageRegistration from "Page/Management/ManageRegistration";
import EditBanner from "Page/Setting/editBanner";
// import PublicPunish from "Page/Punish/publicPunish";
import AuthPunish from "Page/Punish/authPunish";
// import ListReceipt from "Page/Receipt/listReceipt";
// import CreateReceipt from "Page/Receipt/createReceipt";
import VerifyReceipt from "Page/Receipt/verifyReceipt";
import ResultReceipt from "Page/Receipt/resultReceipt";
import StatisticalAccreditation from "Page/Accreditation/StatisticalAccreditation";
// import File from "Page/File";
import PhoneBook from "Page/PhoneBook";
// import Question from "Page/Question/Question";
// import Chat from "Page/Chat";
import LoginSSO from "Page/Login/LoginSSO";
import { USER_ROLES } from "constants/permission";
// import Service from 'Page/Service';
// import PermissionEmployee from "Page/PermissionEmployee";
import VehicleRecordsRegistration from "Page/vehicleRecords/VehicleRecordsRegistration";
import ModalDetailVehicleRecords from "Page/vehicleRecords/ModalDetailVehicleRecords";
import CustomerRegistration from "Page/ListCustomers/CustomerRegistration";
import ReceiptRegistration from "Page/Receipt/ReceiptRegistration";
// import DocumentaryList from "Page/Documentary/DocumentaryList";
import Device from "Page/Device";
import SendSMS from "Page/SMS/SendSMS";
import CameraRegistration from "Page/Camera";
import HomeMenu from "Page/HomeMenu";

/** IMPORT CONSTANT */
// import { INIT } from "constants/introduction";
import { SETTING } from './constants/setting'

/** IMPORT STYLE */
import 'antd/dist/antd.css';
import "./assets/scss/index.scss";
// import EditReceipt from "Page/Receipt/editReceipt";
import addKeyLocalStorage from "helper/localStorage";
import DocumentaryRealTimeEvent from "components/DocumentaryRealTimeEvent/DocumentaryRealTimeEvent";
import MqttConnection from "components/mqttConnection/mqttConnection";
import ModalDetailBooking from "Page/AddBooking/ModalDetailBooking";
import { setMetaData } from "actions";
import ListSchedulesService from "services/listSchedulesService";
import { MOBILE_APP_PERMISSION_TYPE } from "constants/app";
import AccreditationSetting from "Page/Accreditation/AccreditationSetting";
import CustomerSettings from "Page/ListCustomers/CustomerSettings";
import CustomerCreateSetting from "Page/ListCustomers/CustomerCreateSetting";
// import { NOT_AUTHENTICATION } from "constants/permission";
import { NOT_AUTHENTICATION_PERMISSION } from "constants/permission";
import { ALL_PERMISSION } from "constants/permission";
// import { ROLE_ID_DIRECTOR } from "constants/permission";
import { getAllPermissionFormatString } from "constants/permission";
import UnLock from "components/UnLock/UnLock";
import ListOrder from "Page/Order/ListOrder";
import OrderDetail from "Page/Order/OrderDetail";
// import { onMessage , getMessaging , isSupported } from "firebase/messaging";
// import { firebaseConfig } from "firebase/messaging_init_in_sw";
// import { initializeApp } from "firebase/app";
import Torichat from "Page/Torichat/index";
import Affiliate from "Page/Affiliate/index";
// import { healthCheck } from "helper/healthCheck";

const routeNoRender =  {
    path: "/accreditation",
    component: UnLock,
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  }

export const routes = {
  accreditation: {
    path: "/accreditation",
    component: Accreditation,
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  listDetailAccreditation: {
    path: "/list-detail-accreditation",
    component: ListEditAccreditation,
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  inspectionProcess: {
    path: "/inspection-process",
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    component: InspectionProcess,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  accreditationPublic: {
    path: "/accreditation-public",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: false,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: true
    },
    component: AccreditationPublic
  },
  statisticalAccreditation: {
    path: "/statistical-accreditation",
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false
    },
    component: StatisticalAccreditation
  },
  listReportlAccreditation: {
    path: "/list-report-accreditation",
    component: ListReportStaistic,
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  accreditationSetting:{
    path: "/accreditation-setting",
    component: AccreditationSetting,
    permissionName: ALL_PERMISSION.MANAGE_RECORD.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false, // chỉ hiển thị logo ở center,
      permissions:[MOBILE_APP_PERMISSION_TYPE.CAMERA] // Yêu cầu quyền truy cập camera ở mobile khi vào trang
    },
  },
  listCustomer: {
    path: '/list-customers',
    component: CustomerRegistration,
    permissionName: ALL_PERMISSION.MANAGE_CUSTOMER.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  sendSMS: {
    path: "/sms/sendSMS",
    permissionName: ALL_PERMISSION.MANAGE_SMS.permission,
    isAuth: true,
    component: SendSMS,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  sms: {
    path: "/sms",
    permissionName: ALL_PERMISSION.MANAGE_SMS.permission,
    isAuth: true,
    component: SMS,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  customerSchedule: {
    path: '/schedules',
    component: CustomerSchedule,
    permissionName: ALL_PERMISSION.MANAGE_SCHEDULE.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  receipt: {
    path: "/receipt",
    permissionName: ALL_PERMISSION.MANAGE_BILLING.permission,
    isAuth: true,
    component: ReceiptRegistration,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  documentary: {
    path: "/documentary",
    permissionName: ALL_PERMISSION.MANAGE_DOCMENTARY.permission,
    isAuth: true,
    prioritize: true,
    component: Documentary,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false, // chỉ hiển thị logo ở center
      permissions:[MOBILE_APP_PERMISSION_TYPE.CAMERA] // Yêu cầu quyền truy cập camera ở mobile khi vào trang
    }
  },
  device: {
    path: "/device",
    permissionName: ALL_PERMISSION.MANAGEMENT_DEVICE.permission,
    isAuth: true,
    component: Device,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  management: {
    path: "/management",
    permissionName: ALL_PERMISSION.MANAGE_APP_USER.permission,
    isAuth: true,
    component: ManageRegistration,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  vehicleRecords: {
    path: "/vehicleRecords",
    permissionName: ALL_PERMISSION.MANAGE_VEHICLE_RECORD.permission,
    isAuth: true,
    component: VehicleRecordsRegistration,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false, // chỉ hiển thị logo ở center
      permissions:[MOBILE_APP_PERMISSION_TYPE.CAMERA] // Yêu cầu quyền truy cập camera ở mobile khi vào trang
    }
  },
  camera: {
    path: "/camera",
    permissionName: ALL_PERMISSION.MANAGE_CAMERA.permission,
    isAuth: true,
    component: CameraRegistration, // Placeholder for camera page
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
     }
  },
  news: {
    path: "/news",
    component: New,
    permissionName: ALL_PERMISSION.MANAGE_NEWS.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  login: {
    path: "/login",
    component: Login,
    isAuth: false,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: true // chỉ hiển thị logo ở center
    }
  },
  loginSuccess: {
    path: "/login-success",
    component: LoginSuccess,
    isAuth: false,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: true // chỉ hiển thị logo ở center
    }
  },
  fogotPassword: {
    path: "/fogot-password",
    component: FogotPassword,
    isAuth: false,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: true // chỉ hiển thị logo ở center
    }
  },
  LoginSSO: {
    path: "/loginSSO",
    component: LoginSSO,
    isAuth: false,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  twoFAPage: {
    path: "/verifying-user",
    component: TwoFAPage,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: false,
    props: {
      isShowHeader: true,
      isShowFooter: true,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  forgotPass: {
    path: "/forgot-password",
    component: ForgetPass,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: false,
    props: {
      isShowHeader: true,
      isShowFooter: true,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  bookingSchedule: {
    path: "/booking-schedule",
    component: AddBooking,
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: true,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  punishAuth: {
    path: "/auth-punish",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: true,
    component: AuthPunish,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  }, 
  customerScheduleItem: {
    path: '/schedules/:id',
    component: ModalDetailBooking,
    permissionName: ALL_PERMISSION.MANAGE_SCHEDULE.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },

  /* Ẩn vì hiện tại ko thấy dùng ở menu */
  // service: {
  //   path: '/service',
  //   component: Service,
  //   permissionName: "MANAGE_SERVICE",
  //   isAuth: true,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
 
  customerSettingDetail:{
    path: '/customer-setting-detail/:id',
    component: CustomerSettings,
    permissionName: ALL_PERMISSION.MANAGE_CUSTOMER.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false 
    }
  },
  customerSettingCreate:{
    path: '/customer-setting-create',
    component: CustomerCreateSetting,
    permissionName: ALL_PERMISSION.MANAGE_CUSTOMER.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false 
    }
  },

  // /* Ẩn vì hiện tại ko thấy dùng ở menu */
  // question: {
  //   path: '/question',
  //   component: Question,
  //   permissionName: "MANAGE_GUIDE",
  //   isAuth: true,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  
  
  
  
  setting: {
    path: "/setting",
    component: Setting,
    permissionName: ALL_PERMISSION.MANAGE_SETTINGS.permission,
    isAuth: true,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false, // chỉ hiển thị logo ở center,
      permissions:[MOBILE_APP_PERMISSION_TYPE.CAMERA] // Yêu cầu quyền truy cập camera ở mobile khi vào trang

    }
  },
  /* Ẩn vì hiện tại ko thấy dùng ở đâu hết */
  // statistical: {
  //   path: "/statistical",
  //   permissionName: "MANAGE_STATISTICAL",
  //   isAuth: true,
  //   component: Statistical,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  
  /* 
    Ẩn vì hiện tại đã chuyển vào tab
  */
  // file: {
  //   path: "/file",
  //   permissionName: "MANAGE_FILE",
  //   isAuth: true,
  //   component: File,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  phonebook: {
    path: "/phonebook",
    permissionName: ALL_PERMISSION.MANAGE_PHONEBOOK.permission,
    isAuth: true,
    component: PhoneBook,
    prioritize: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  vehicleRecordsDetail: {
    path: "/vehicleRecordsDetail/:id",
    permissionName: ALL_PERMISSION.MANAGE_VEHICLE_RECORD.permission,
    isAuth: true,
    component: ModalDetailVehicleRecords,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false // chỉ hiển thị logo ở center
    }
  },
  
  /* Ẩn vì hiện tại đã chuyển vào tab  */
  // explain: {
  //   path: "/explain-power",
  //   permissionName: NOT_AUTHENTICATION_PERMISSION,
  //   isAuth: true,
  //   component: Explaintation,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  // employee: {
  //   path: "/permission-employee",
  //   permissionName: NOT_AUTHENTICATION_PERMISSION,
  //   isAuth: true,
  //   component: PermissionEmployee,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  // createCustomer: { // không thấy dùng
  //   path: "/create-customer",
  //   permissionName: "MANAGE_RECORD",
  //   isAuth: true,
  //   component: CreateNewCustomer,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },


  /* 
    Ẩn vì hiện tại đã chuyển vào tab
  */
  // punishPublic: {
  //   path: '/public-punish',
  //   permissionName: NOT_AUTHENTICATION_PERMISSION,
  //   isAuth: false,
  //   component: PublicPunish,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: true,
  //     isShowMenu: true,
  //     isHeaderTextOnly: true // chỉ hiển thị logo ở center
  //   }
  // },
  
  /* 
     Ẩn vì hiện tại không thấy dùng
  */
  // chat: {
  //   path: "/chat",
  //   permissionName: ALL_PERMISSION.MANAGE_CHAT.permission,
  //   isAuth: true,
  //   component: Chat,
  //   prioritize: true,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: false,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false // chỉ hiển thị logo ở center
  //   }
  // },
  verifyReceipt: {
    path: "/verify-receipt",
    // permissionName: "MANAGE_BILLING",
    permissionName: ALL_PERMISSION.MANAGE_BILLING.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: true,
      isShowMenu: false,
      isHeaderTextOnly: true
    },
    component: VerifyReceipt
  },
  resultReceipt: {
    path: "/result-receipt",
    permissionName: ALL_PERMISSION.MANAGE_BILLING.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: true,
      isShowMenu: false,
      isHeaderTextOnly: true
    },
    component: ResultReceipt
  },
  // landingPage: {
  //   path: "/",
  //   isAuth: false,
  //   props: {
  //     isShowHeader: true,
  //     isShowFooter: true,
  //     isShowMenu: true,
  //     isHeaderTextOnly: false
  //   },
  //   component: LandingPage
  // },
  editBanner: {
    path: "/edit-banner",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: true,
    props: {
      isShowHeader: false,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: false
    },
    component: EditBanner
  },
  
  editLandingPage: {
    path: "/edit-landing-page",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: false,
    props: {
      isShowHeader: false,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: false
    },
    component: SettingLandingPage
  },

  listOrder: {
    path: "/orders",
    permissionName: ALL_PERMISSION.MANAGE_ORDER.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false
    },
    component: ListOrder
  },
  orderDetail: {
    path: "/order-detail/:id",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: false,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false
    },
    component: OrderDetail
  },
  homeMenu: {
    path:  "/homeMenu",
    permissionName: NOT_AUTHENTICATION_PERMISSION,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: false,
      isHeaderTextOnly: false
    },
    component: HomeMenu
  },
  torichat: {
    path:  "/torichat",
    permissionName: ALL_PERMISSION.MANAGE_TORICHAT.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false
    },
    component: Torichat
  },
  affiliate: {
    path:  "/affiliate",
    permissionName: ALL_PERMISSION.MANAGE_AFFILIATE.permission,
    isAuth: true,
    props: {
      isShowHeader: true,
      isShowFooter: false,
      isShowMenu: true,
      isHeaderTextOnly: false
    },
    component: Affiliate
  }
}

function renderRoutes(permission, roleId, username) {
  const allPermission = getAllPermissionFormatString() || "";
  const allPermissionArray = String(allPermission).split(',');

  const routerNoLogin = {
    fogotPassword: routes.fogotPassword,
    login: routes.login,
    twoFAPage: routes.twoFAPage,
    LoginSSO: routes.LoginSSO,
  };

  if (!permission && !username) {
    localStorage.removeItem(addKeyLocalStorage("isUserLoggedIn"));
    localStorage.removeItem(addKeyLocalStorage("data"));
    return routerNoLogin;
  }

  const routeCheckedPermission = Object.entries(routes).reduce((acc, [key, value]) => {
    const routePermission = value.permissionName;

    if (routePermission === NOT_AUTHENTICATION_PERMISSION) {
      acc[key] = value;
      return acc;
    }

    if (!routePermission || !allPermissionArray.includes(routePermission)) {
      console.error(`Route "${key}" có quyền không hợp lệ: "${routePermission}"`);
      notification["error"]({
        message: "",
        description: `⚠️ Quyền "${routePermission}" của route "${key}" không nằm trong ALL_PERMISSION ở constants/permission.js`,
      });
      return acc;
    }

    // Keep protected routes registered so Layout can render the page-level
    // permission message instead of preventing homepage tiles from navigating.
    acc[key] = value;
    return acc;
  }, {});


  //Lọc để lấy key mặc định
  const routeCheckedPermissionForDefault = (Object.values(routeCheckedPermission)).filter(
    (route) => route.permissionName !== NOT_AUTHENTICATION_PERMISSION
  );

  // Ưu tiên route có prioritize === true
  const prioritizedRoute = routeCheckedPermissionForDefault.find((route) => route.prioritize);

  // Nếu có prioritize thì dùng, không thì lấy cái đầu tiên
  const defaultRoute = prioritizedRoute || routeCheckedPermissionForDefault[0] || routeNoRender

  routeCheckedPermission.home = routes.homeMenu

  return routeCheckedPermission;
}

function App() {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.member)
  const [isLoading , setIsLoading] = useState(true);
  const { isUserLoggedIn, permissions, appUserRoleId, username } = user
  const stationsColorset = useSelector((state) => state.setting ? state.setting.stationsColorset : "")
  let mainRoutes = renderRoutes(permissions, appUserRoleId, user.username);
  const themeApp=process.env.REACT_APP_THEME_NAME
  const setThemeApp=()=>{
    document.querySelector('body').setAttribute('data-theme',themeApp)
  }
  useEffect(() => {
    setThemeApp()
    // healthCheck()
    console.log("version web", process.env.REACT_APP_BUILD_VERSION)
  }, [])
  useEffect(() => {
    const DOMAIN = window.origin.split('://')[1]
    setIsLoading(true);
    if (user.stationsId) {
      InspectionProcessService.getDetailById({ id: user.stationsId }).then(result => {
        if (result) {
          dispatch({ type: SETTING, data: result })
        }
        setIsLoading(false);
      })
    } else {
      const DOMAIN = window.origin.split('://')[1]
      setIsLoading(false);
    }
  }, [user.stationsId])

  notification.config({
    closeIcon: () => { },
    duration: 5
  })

  const handleEventFireBaseMessage =  async () => {
    // Kiểm tra trình duyệt hỗ trợ FireBase Message
    const hasFirebaseMessagingSupport = false //await isSupported();
    if (hasFirebaseMessagingSupport) { 
      const app = {} // initializeApp(firebaseConfig);
      const messaging =  {} // getMessaging(app);

      // onMessage(messaging, (payload) => {
      //   if ('serviceWorker' in navigator) {
      //     navigator.serviceWorker.register('../firebase-messaging-sw.js')
      //       .then(function (registration) {
      //         const notificationTitle = payload.notification.title;
      //         const notificationOptions = {
      //           body: payload.notification.body,
      //           icon: payload.notification.image,
      //         };

      //         registration.showNotification(notificationTitle, notificationOptions);
      //       }).catch(function (err) {
      //         console.log('Service worker registration failed, error:', err);
      //       });
      //   }

      // });
    }
  }
  useEffect(() => {
    handleEventFireBaseMessage();
    fetchListMetaData()
  }, [])

  if(isLoading) {
    return <Spin />
  }

  function fetchListMetaData() {
    ListSchedulesService.getMetaData({}).then(result => {
      if (result)
      dispatch(setMetaData(result))
      window.localStorage.setItem(('metaData'), JSON.stringify(result))
    })
  }
  
  return (
    <div className={stationsColorset}>
      <DocumentaryRealTimeEvent isAdmin={appUserRoleId === USER_ROLES.ADMIN} />
      <MqttConnection />
      <Router>
        <Switch>

          {Object.keys(mainRoutes).map((key, index) => {
            return <Route key={index} extract path={mainRoutes[key].path} component={(props) => <Layout  {...mainRoutes[key].props} {...props} Component={mainRoutes[key].component} isAuth={mainRoutes[key].isAuth} permission={mainRoutes[key].permissionName} />}/>
          })}

          {(!user || !isUserLoggedIn) ? (
            <Route path="*" component={props => (
              <Redirect
            to={{
              pathname: "/login",
              search: `?redirect=${encodeURIComponent(
                props.location.pathname + props.location.search
              )}`
            }}
          />
            )}
            />
          ) : (
            <Route path='/' exact component={(props) => <Layout  {...props} {...mainRoutes.home.props} Component={mainRoutes.home.component} isAuth={true} permission={mainRoutes.home.permissionName}/>}/>
          )}

          <Route path="*" component={props => (
            <Redirect to="/" />
          )}
          />
        </Switch>
      </Router>

    </div>
  );
}

export default App